import React from "react";

import { useHistory } from "react-router-dom";

import {
  Button,
  Grid,
  Icons,
  Text,
  useDevice,
} from "@pushpress/shared-components";

interface ClassTypesHeaderProps {
  onAddClassTypeClick: VoidFunction;
}

function ClassTypesHeader(props: ClassTypesHeaderProps) {
  const { onAddClassTypeClick } = props;

  const { isMobile } = useDevice();
  const history = useHistory();

  const buttonSize = isMobile ? "medium" : "large";

  return (
    <>
      <Grid container columnSpacing={3} alignItems="center">
        <Grid item xs={12}>
          <Button
            onClick={() =>
              history.length > 0 ? history.goBack() : history.push("/schedule")
            }
            buttonType="text"
            text="Back"
            icon={Icons.ArrowLeft}
            iconLocation="left"
          />
        </Grid>
        <Grid item xs={9}>
          <Text variant="heading-3" color="wolf-800">
            Class types
          </Text>
        </Grid>
        <Grid item xs={3} container justifyContent="flex-end">
          <Button
            text="Class type"
            icon={Icons.Plus}
            iconLocation="left"
            buttonType="primary"
            size={buttonSize}
            hideTextOnMobile
            onClick={onAddClassTypeClick}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default ClassTypesHeader;
